import { CheckCircle2 } from 'lucide-react';
import { differentiators, focusAreas } from '../data/site';

type Page = 'home' | 'services' | 'case-studies' | 'industries' | 'about' | 'insights' | 'contact';

export function About({ onNavigate }: { onNavigate: (page: Page) => void }) {
  return (
    <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
      <div className="grid gap-10 lg:grid-cols-[0.95fr_1.05fr]">
        <div>
          <p className="section-eyebrow">About</p>
          <h1 className="section-title">Enterprise Platform Engineer and Technical Architect.</h1>
          <div className="mt-6 grid gap-5 text-base leading-7 text-slate-600">
            <p>
              I am an Enterprise Platform Engineer and Technical Architect with 17+ years of experience delivering
              large-scale software platforms across government, finance, ecommerce, regulatory, and startup environments.
            </p>
            <p>
              Throughout my career, I have led the design and delivery of mission-critical cloud-native platforms,
              enterprise APIs, identity systems, distributed architectures, and modern web applications.
            </p>
            <p>
              I work hands-on across the full software development lifecycle, from architecture and technical strategy
              through engineering delivery, cloud deployment, governance, and operational support.
            </p>
          </div>
          <button className="btn-primary mt-8" onClick={() => onNavigate('contact')}>
            Book a Consultation
          </button>
        </div>

        <div className="rounded border border-slate-200 bg-white p-6 shadow-soft">
          <h2 className="text-xl font-bold">Experience spans</h2>
          <div className="mt-5 grid gap-3 sm:grid-cols-2">
            {focusAreas.map((item) => (
              <p key={item} className="flex gap-2 text-sm text-slate-700">
                <CheckCircle2 className="mt-0.5 shrink-0 text-cyan" size={17} />
                {item}
              </p>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-14 grid gap-5 md:grid-cols-3">
        {differentiators.map((item) => (
          <article key={item.title} className="rounded border border-slate-200 bg-white p-6">
            <item.icon className="text-cyan" size={28} aria-hidden="true" />
            <h2 className="mt-5 text-xl font-bold">{item.title}</h2>
            <p className="mt-3 text-sm leading-6 text-slate-600">{item.text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
